import { ajax } from "@/assets/js/ajax";
import store from "@/store";
export function oneAdd(data, StepLite) {
  //一审立案审查中
  return ajax({
    url:
      StepLite == 10 || StepLite == 121 || StepLite == 15
        ? "step/lascz/one/add"
        : StepLite == 70 || StepLite == 115
        ? "step/lascz/two/add"
        : "step/lascz/three/add",
    data: data,
    contentType: "application/json",
  });
}

export function oneEdit(data, StepLite) {
  //一审立案审查中修改
  return ajax({
    updateTime: store.state.updateTime,
    url:
      StepLite == 10 || StepLite == 121 || StepLite == 15
        ? "step/lascz/one/edit"
        : StepLite == 70 || StepLite == 115
        ? "step/lascz/two/edit"
        : "step/lascz/three/edit",
    data: data,
    contentType: "application/json",
  });
}

export function lasczDetails(data) {
  //一审详情
  return ajax({
    url: "step/lascz/lists",
    data: data,
    type: "get",
  });
}

export function jzyjAdd(data, StepLite) {
  //卷宗移交时间
  return ajax({
    url: "step/jzyj/add",
    data: data,
  });
}

export function jzyjEdit(data) {
  //卷宗移交时间
  return ajax({
    updateTime: store.state.updateTime,
    url: "step/jzyj/edit",
    data: data,
    contentType: "application/json",
  });
}

export function jzyjLists(data) {
  //卷宗移交时间
  return ajax({
    url: "step/jzyj/lists",
    data: data,
    type: "get",
  });
}

export function ssclzbAdd(data, StepLite) {
  //诉讼材料制作
  return ajax({
    url: "step/ssclzb/add",
    data: data,
  });
}

export function ssclzbEdit(data) {
  //卷宗移交时间
  return ajax({
    url: "step/ssclzb/edit",
    data: data,
    updateTime: store.state.updateTime,
  });
}

export function ssclzbLists(data) {
  //卷宗移交时间
  return ajax({
    url: "step/ssclzb/lists",
    data: data,
    type: "get",
  });
}

export function jcyspjdAdd(data, StepLite) {
  //涉刑案件侦查添加//中止/终止审理
  return ajax({
    url: StepLite == "120" ? "step/sxajzc/add" : "step/jcyspjd/add",
    data: data,
    contentType: "application/json",
  });
}

export function jcyspjdEdit(data, StepLite) {
  //涉刑案件侦查修改
  return ajax({
    url: StepLite == "120" ? "step/sxajzc/edit" : "step/jcyspjd/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}

export function jcyspjdLists(data, StepLite) {
  //涉刑案件侦查列表
  return ajax({
    url: StepLite == "120" ? "step/sxajzc/lists" : "step/jcyspjd/lists",
    data: data,
    type: "get",
  });
}

export function twosAdd(data) {
  //调解新增
  return ajax({
    url: "step/stz/add",
    data: data,
    contentType: "application/json",
  });
}
export function twosEdit(data) {
  //一审调度修改
  return ajax({
    url: "step/stz/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}
export function twosDetails(data) {
  //一审详情
  return ajax({
    url: "step/stz/lists",
    data: data,
    type: "get",
  });
}
export function laAdd(data) {
  //一审立案 新增
  return ajax({
    url: "step/la/add",
    data: data,
    contentType: "application/json",
  });
}

export function laEdit(data) {
  //一审立案 修改
  return ajax({
    url: "step/la/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}

export function laDetails(data) {
  //一审立案详情
  return ajax({
    url: "step/la/lists",
    data: data,
    type: "get",
  });
}

export function dktAdd(data) {
  // 一审待开庭
  return ajax({
    url: "step/dkt/add",
    data: data,
    contentType: "application/json",
  });
}
export function dktEdit(data) {
  return ajax({
    url: "step/dkt/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}
export function dktDetails(data) {
  return ajax({
    url: "step/dkt/lists",
    data: data,
    type: "get",
  });
}

export function dpjAdd(data) {
  // 一审待判决
  return ajax({
    url: "step/dpj/add",
    data: data,
    contentType: "application/json",
  });
}
export function dpjEdit(data) {
  return ajax({
    url: "step/dpj/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}
export function dpjList(data) {
  return ajax({
    url: "step/dpj/lists",
    data: data,
    type: "get",
  });
}

export function cpwsAdd(data) {
  // 一审裁判文书;
  return ajax({
    url: "step/cpws/add",
    data: data,
    contentType: "application/json",
  });
}
export function cpwsEdit(data) {
  return ajax({
    url: "step/cpws/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}
export function cpwsList(data) {
  return ajax({
    url: "step/cpws/lists",
    data: data,
    type: "get",
  });
}

export function zsAdd(data) {
  //再审
  return ajax({
    url: "step/zs/add",
    data: data,
  });
}

export function zsEdit(data) {
  //修改
  return ajax({
    url: "step/zs/edit",
    data: data,
    contentType: "application/json",
  });
}

export function zsLists(data) {
  //再审详情
  return ajax({
    url: "step/zs/lists",
    data: data,
    type: "get",
  });
}

// 1. 状态码常量（新增中止执行区间）
const EXECUTION_STATUS = {
  EXECUTING: 150,        // 执行中
  TERMINATED: 160,       // 终本
  RESUME_TERMINATED_MIN: 161, // 执恢终本起始
  RESUME_TERMINATED_MAX: 169, // 执恢终本结束
  RESUME_EXECUTE_MIN: 170,    // 恢复执行起始
  RESUME_EXECUTE_MAX: 179,    // 恢复执行结束
  OTHER_180: 180,             // 未标注状态
  DEBTOR_CLEAR: 181,          // 被告结清
  SUSPENDED_EXECUTE_MIN: 185, // 中止执行起始
  SUSPENDED_EXECUTE_MAX: 189, // 中止执行结束
};

// 2. 统一接口配置（新增中止执行区间匹配）
const API_CONFIG = {
  getPrefix(key) {
    const numKey = Number(key);
    if (isNaN(numKey)) return null;

    // 中止执行（185-189）
    if (numKey >= EXECUTION_STATUS.SUSPENDED_EXECUTE_MIN && numKey <= EXECUTION_STATUS.SUSPENDED_EXECUTE_MAX) {
      return 'zzzx'; // 替换为你实际的中止执行接口前缀（如zhongzhi）
    }
    // 执恢终本（161-169）
    if (numKey >= EXECUTION_STATUS.RESUME_TERMINATED_MIN && numKey <= EXECUTION_STATUS.RESUME_TERMINATED_MAX) {
      return 'zhzb';
    }
    // 恢复执行（170-179）
    if (numKey >= EXECUTION_STATUS.RESUME_EXECUTE_MIN && numKey <= EXECUTION_STATUS.RESUME_EXECUTE_MAX) {
      return 'hfzx';
    }
    // 单个状态码匹配
    const prefixMap = {
      [EXECUTION_STATUS.EXECUTING]: 'zxz',
      [EXECUTION_STATUS.TERMINATED]: 'zb',
      [EXECUTION_STATUS.OTHER_180]: 'ja',
    };
    return prefixMap[numKey] || null;
  },
  getApiUrl(key, action) {
    const numKey = Number(key);
    // 181 特殊处理
    if (numKey === EXECUTION_STATUS.DEBTOR_CLEAR) {
      const actionMap = {
        add: 'debtor/set_clear',
        edit: 'debtor/edit_clear',
      };
      return actionMap[action] || '';
    }
    // 其他状态码拼接路径
    const prefix = this.getPrefix(numKey);
    return prefix ? `step/${prefix}/${action}` : '';
  },
  delClearUrl: 'debtor/del_clear',
};

// 3. 容错辅助函数
function getSafeZblastConfig(key, action) {
  const url = API_CONFIG.getApiUrl(key, action);
  if (!url) {
    throw new Error(`状态码${key}无${action}接口配置`);
  }
  return { url };
}

// 4. 业务函数（完全保留原有逻辑，无需修改）
export function zblastAdd(data, key) {
  try {
    const { url } = getSafeZblastConfig(key, 'add');
    return ajax({
      url,
      data,
      contentType: 'application/json',
    });
  } catch (error) {
    console.error('zblastAdd 配置异常：', error.message);
    return Promise.reject(error);
  }
}

export function zblastEdit(data, key) {
  try {
    const { url } = getSafeZblastConfig(key, 'edit');
    return ajax({
      url,
      type: Number(key) === EXECUTION_STATUS.DEBTOR_CLEAR ? 'put' : 'post',
      data,
      contentType: 'application/json',
      updateTime: store.state.updateTime,
    });
  } catch (error) {
    console.error('zblastEdit 配置异常：', error.message);
    return Promise.reject(error);
  }
}

export function zblastDel(data) {
  return ajax({
    url: API_CONFIG.delClearUrl,
    type: 'delete',
    data,
  });
}

export function zblastLists(data, key) {
  try {
    const numKey = Number(key);
    if (numKey === EXECUTION_STATUS.DEBTOR_CLEAR) {
      return new Promise((resolve) => {
        resolve({
          list: [{ jq: JSON.parse(JSON.stringify(store.getters.debInfo.clear)) }],
        });
      });
    }
    const { url } = getSafeZblastConfig(key, 'lists');
    return ajax({
      url,
      data,
      type: 'get',
    });
  } catch (error) {
    console.error('zblastLists 配置异常：', error.message);
    return Promise.reject(error);
  }
}

export function with_debtor(data) {
  //执行中详情
  return ajax({
    url: "cause/accuser_with_debtor",
    data: data,
    type: "get",
  });
}

export function delJd(data) {
  return ajax({
    url: "step/delete",
    data: data,
    type: "get",
  });
}

//添加进度-记录添加代理人信息
export function addAgentinfo(data) {
  return ajax({
    url: "cause/stage/add",
    data: data,
    type: "post",
  });
}
//修改进度-记录修改代理人信息
export function editAgentinfo(data) {
  return ajax({
    url: "cause/stage/edit",
    data: data,
    type: "post",
  });
}
//删除进度-记录删除代理人信息
export function delAgentinfo(data) {
  return ajax({
    url: "cause/stage/del",
    data: data,
    type: "post",
  });
}

//诉前保全详情
export function sqbqlists(data) {
  return ajax({
    url: "step/sqbq/lists",
    data: data,
    type: "get",
  });
}

//诉前保全进度添加
export function sqbqadd(data) {
  return ajax({
    url: "step/sqbq/add",
    data: data,
    contentType: "application/json",
  });
}

//诉前保全进度修改
export function sqbqedit(data) {
  return ajax({
    url: "step/sqbq/edit",
    data: data,
    contentType: "application/json",
  });
}

//执恢终本详情
export function zhzblists(data) {
  return ajax({
    url: "step/zhzb/lists",
    data: data,
    type: "get",
  });
}

//执恢终本进度添加
export function zhzbadd(data) {
  return ajax({
    url: "step/zhzb/add",
    data: data,
    contentType: "application/json",
  });
}

//执恢终本进度修改
export function zhzbedit(data) {
  return ajax({
    url: "step/zhzb/edit",
    data: data,
    contentType: "application/json",
  });
}

//获取费用
export function instanceDetail(data) {
  return ajax({
    url: "cause/instance/detail",
    data: data,
    type: "get",
  });
}

//修改费用
export function setInstance(data) {
  return ajax({
    url: "cause/instance/change",
    data: data,
    type: "post",
    contentType: "application/json",
  });
}

//修改当前最新进度
export function setnewStep(data) {
  return ajax({
    url: "v2/cause/latest_step",
    data: data,
    type: "post",
  });
}